import React from "react";
import Typography from "@mui/material/Typography";
import { Inline, Stack } from "components/layout/reusableLayouts";

interface PanelSectionProps {
  title: string;
  /** Status mark or category glyph, rendered before the title. */
  icon?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * A titled block inside a panel: the leading glyph and heading an accordion
 * used to carry, minus the collapse. Shared so the sections that came off
 * accordions keep one heading, since several of them sit in the same drawer.
 */
const PanelSection: React.FC<PanelSectionProps> = ({
  title,
  icon,
  children,
}) => (
  <Stack gap="var(--space-4)">
    <Inline gap="var(--space-3)" align="center" wrap={false}>
      {icon}
      <Typography
        variant="label"
        component="h3"
        sx={{ color: "var(--color-text-tertiary)" }}
      >
        {title}
      </Typography>
    </Inline>
    {children}
  </Stack>
);

export default PanelSection;
